import { Component, HostBinding, Input, OnInit, inject } from '@angular/core';
import {LoginService} from '../../../../../app/main/auth/login/login.service';
import { NgClass, NgTemplateOutlet, NgStyle } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {MatIcon} from "@angular/material/icon";

import { TranslateDirective } from '@ngx-translate/core';
import { MatBadge } from '@angular/material/badge';

@Component({
    selector: 'cdk-nav-horizontal-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    imports: [NgClass, RouterLink, RouterLinkActive, NgTemplateOutlet, MatIcon, TranslateDirective, NgStyle, MatBadge]
})
export class CdkNavHorizontalItemComponent implements OnInit
{
    _loginService = inject(LoginService);

    @HostBinding('class')
    classes = 'nav-item';

    @Input()
    item: any;

    isGrantedRole: boolean;
    isCoordenador: boolean;



    constructor()
    {
    }

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.isGrantedRole = true;

        if (this.item.role) {
            this.isGrantedRole = false;
            if (Array.isArray(this.item.role)) {
                this.item.role.forEach((role) => {
                    if (!this.isGrantedRole) {
                        this.isGrantedRole = this._loginService.isGranted(role);
                    }
                });
            } else {
                this.isGrantedRole = this._loginService.isGranted(this.item.role);
            }
        }

        this.isCoordenador = this._loginService.isCoordenador();
    }
}
